import Calendar from './calendar';
import Chart from './chart';
import {getKoyomi} from './Koyomi';
import './App.css';

function App() {
  // URLのクエリストリングを解析
  const queryParameters = new URLSearchParams(window.location.search);

  // 'date' パラメータを取得 (例: "202310")
  const dateStr = queryParameters.get('date');
  // 'area' パラメータを取得。許可された値以外は 'aks' を使用
  const areaParam = queryParameters.get('area');
  const allowedAreas = ['aks', 'aks3', 'tmg', 'nrt'];
  const area = allowedAreas.includes(areaParam) ? areaParam : 'aks';

  // areaの値に応じてタイトルを動的に設定
  const areaNames = {
    aks: '明石海峡',
    aks3: '明石海峡（3号灯浮標付近）',
    tmg: '友ヶ島水道',
    nrt: '鳴門海峡'
  };
  const title = `${areaNames[area]}潮流カレンダー`;

  // areaに応じた方角のテキスト
  const areaDirections = {
    aks: { neg: '東', pos: '西' },
    aks3: { neg: '東', pos: '西' },
    tmg: { neg: '南', pos: '北' },
    nrt: { neg: '南', pos: '北' },
  };
  const direction = areaDirections[area] || areaDirections['aks'];

  // 'date' パラメータを基にDateオブジェクトを生成。
  // 不正な形式または指定がない場合は、現在の日付を使用。
  let initialDate;
  if (dateStr && /^\d{6}$/.test(dateStr)) {
    // YYYYMMをYYYY-MM-01として解釈することで、その月のカレンダーを表示
    const year = dateStr.substring(0, 4);
    const month = dateStr.substring(4, 6);
    initialDate = new Date(`${year}-${month}-01`);
  } else {
    initialDate = new Date();
  }

  return (
    <div className="App">
      <header className="App-header">
        <div>{title}</div>
      </header>
      <body className="App-body">
        <Calendar
          date={initialDate}
          renderItem = {(date) => {
            const koyomi = getKoyomi(date);
            const top = [
                `旧暦 ${koyomi.KyuuReki.toString('{m}/{d}')}`,
                `${koyomi.You.text}`
            ];
            const middle = [
                `${koyomi.Kan.kana}${koyomi.Shi.kana}`
            ];
            const bottom = [];
            if (koyomi.Appendix.Sun ?? false){bottom.push(koyomi.Appendix.Sun)}
            if (koyomi.Appendix.Moon ?? false){bottom.push(koyomi.Appendix.Moon)}
            if (koyomi.Appendix.ZasSetsu ?? false){bottom.push(koyomi.Appendix.ZasSetsu)}
            return (
              <>
                <div className="Top">{`${date.getMonth()+1}/${date.getDate()} ${koyomi.Moon.text} ${koyomi.Shio.text}`}</div>
                <div className="Middle">{`${top.join('　')}`}</div>
                <div className="Middle">{`${middle.join('　')}`}</div>
                <div className="Bottom">{`　${bottom.join('　')}　`}</div>
                <Chart key={date} date={date} area={area} direction={direction} />
              </>
            )
          }}
        />
      </body>
      <footer className="App-footer">
        潮流データは<a href='https://www1.kaiho.mlit.go.jp/KAN5/tyouryuu/stream_akashi.html'>第五管区海上保安本部 海洋情報部の明石海峡潮流情報</a>を<small>（こっそり）</small>使用しています。
      </footer>
    </div>
  );
}

export default App;
